class VwKdKullaniciRolDTO {
    id?: number;
    roltanimId?: number;
    roladi?: string;
    raporsorguId?: number;
    fkRaporgrup?: number;
    grupAdi?: string;
    kullaniciId?: number;
    sira?: number;
    raporAdi?: string;
    enTip?: number;
    pivotgrafikaktif?: string;
}
export default VwKdKullaniciRolDTO;